import React, { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

const buildOptions = (autoHide) => ({
  scrollbars: {
    theme: 'os-theme-jeddle',
    autoHide,
    visibility: 'auto',
    clickScroll: true,
  },
});

const ScrollableArea = forwardRef(function ScrollableArea(
  { children, options, autoHide = 'never', className, style, ...rest },
  ref,
) {
  const osRef = useRef(null);

  const resolvedOptions = useMemo(
    () => options || buildOptions(autoHide),
    [options, autoHide],
  );

  useImperativeHandle(
    ref,
    () => {
      const viewport = osRef.current?.osInstance()?.elements().viewport;
      return viewport || null;
    },
    [],
  );

  return (
    <OverlayScrollbarsComponent
      ref={osRef}
      element="div"
      className={className}
      style={style}
      options={resolvedOptions}
      defer
      {...rest}
    >
      {children}
    </OverlayScrollbarsComponent>
  );
});

export default ScrollableArea;
